<!-- 操作弹框 -->
<template>
  <div class="operateOne">
    <div class="operateList">
      <img
        class="img"
        style="transform: rotate(180deg)"
        src="../../assets/images/icon-handle-down.png"
      />
      <img
        class="imgOn"
        src="../../assets/images/icon-handle-up-active.png"
      />
      向上插入
      <i class="el-icon-arrow-right"></i>
      <div class="operateTwo">
        <div class="operateList" v-if="optTestLevel === 1" @mousedown.prevent.stop="insertLevelNode(true, 1)">
            <i class="el-icon-caret-bottom" style="color: #FA80C6;"/>
            一级
        </div>
        <div class="operateList" v-if="optTestLevel === 2" @click="insertLevelNode(true, 2)">
            <i class="el-icon-caret-bottom" style="color: #3987EF;"/>
            二级
        </div>
        <div class="operateList" v-if="optTestLevel === 3" @click="insertLevelNode(true, 3)">
            <i class="el-icon-caret-bottom" style="color: #FCCA00;"/>
            三级
        </div>
        <div class="operateList" v-if="optTestLevel === 4" @click="insertLevelNode(true, 4)">
            <i class="el-icon-caret-bottom" style="color: #333333;"/>
            四级
        </div>
      </div>
    </div>
    <div class="operateList">
      <img
        class="img"
        src="../../assets/images/icon-handle-down.png"
        alt=""
      />
      <img
        class="imgOn"
        src="../../assets/images/icon-handle-up-active.png"
        style="transform: rotate(180deg)"
      />
      向下插入
      <i class="el-icon-arrow-right"></i>
      <div class="operateTwo">
        <!-- <div class="operateList" v-if="optTestLevel === 1" @click="insertLevelNode(false, 1)">
            <i class="el-icon-caret-bottom" style="color: #FA80C6;" />
            一级
        </div>
        <div class="operateList" v-if="optTestLevel === 1 || optTestLevel === 2" @click="insertLevelNode(false, 2)">
            <i class="el-icon-caret-bottom" style="color: #3987EF;"/>
            二级
        </div>
        <div class="operateList" v-if="optTestLevel === 2 || optTestLevel === 3" @click="insertLevelNode(false, 3)">
            <i class="el-icon-caret-bottom" style="color: #FCCA00;"/>
            三级
        </div>
        <div class="operateList" v-if="optTestLevel === 3 || optTestLevel === 4" @click="insertLevelNode(false, 4)">
            <i class="el-icon-caret-bottom" style="color: #333333;"/>
            四级
        </div> -->
        <div class="operateList" v-if="showLeve(1)" @click="insertLevelNode(false, 1)">
            <i class="el-icon-caret-bottom" style="color: #FA80C6;" />
            一级
        </div>
        <div class="operateList" v-if="showLeve(2)" @click="insertLevelNode(false, 2)">
            <i class="el-icon-caret-bottom" style="color: #3987EF;"/>
            二级
        </div>
        <div class="operateList" v-if="showLeve(3)" @click="insertLevelNode(false, 3)">
            <i class="el-icon-caret-bottom" style="color: #FCCA00;"/>
            三级
        </div>
        <div class="operateList" v-if="showLeve(4)" @click="insertLevelNode(false, 4)">
            <i class="el-icon-caret-bottom" style="color: #333333;"/>
            四级
        </div>
      </div>
    </div>
    <div class="operateList" @click="createPaper">
      <img
        class="img"
        style="transform: rotate(180deg)"
        src="../../assets/images/icon-addSelect.png"
      />
      <img
        class="imgOn"
        src="../../assets/images/icon-add.png"
      />
      创建试题
    </div>
    <div class="operateList" @click="operateDelete">
      <img
        class="img"
        src="../../assets/images/icon-handle-delete.png"
        alt=""
      />
      <img
        class="imgOn"
        src="../../assets/images/icon-handle-delete-select.png"
      />
      删除
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import {
    addStar,
    deleteStar
} from "@/api/addModule";

export default {
  name: "OperateFrame",
  props: {
    optTestLevel: {
      type: Number,
    },
    childLevel: {
      type: Number,
    },
    optTestLevelId: {
      type: Number,
    },
    optTextLevelLabel: {
        type: String
    },
    showLevelArr:{
      type: Array,
      default: ()=>[]
    }
  },
  computed:{
    showLeve(){
      return function(level) {
          return this.showLevelArr.indexOf(level)==-1?false:true
      }
      // return true//this.showLevelArr.indexOf(level)
    }
  },
  data() {
    return {
        isCollection: false,
        collectionContentSingleId:0,
       // optTestLevel:0,
        //optTestLevelId:0,
    };
  },
  watch: {
    /* testLevel: {
      handler(newValue) {
        this.optTestLevel = newValue
      },
      deep: true,
    }, */
  },
  methods: {
    insertLevelNode(direction, level) {
        this.$emit("insertTreeLevelNode", this.optTestLevelId, direction, level);
    },
    // 插入空白栏位 direction：true // 向上  flase // 向下
    operateInsertBlank(direction) {
      this.$emit("operateInsertBlank", direction, this.id);
    },

    // 复制栏位
    operateCopy() {
      this.$emit("operateCopy", this.id);
    },

    // 插入收藏栏位
    operateInsertCollection(direction) {
		console.log('插入收藏栏位');
		EventBus.$emit("scjShow", {n1:true,n2:true,nowId: this.id, direction: direction, from: "content"});
	},

    // 删除栏位
    operateDelete() {
      this.$confirm(`删除后，该试题层级及其子集下的所有试题内容和答题流程也将一并删除，且不可恢复！`, "是否删除该试题层级？", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass_s",
        cancelButtonClass: "btnCancel_s",
        confirmButtonClass: "btnConfirm_s",
      })
        .then(() => {
          EventBus.$emit("deleteTestLevel", this.optTestLevelId)
        })
        .catch(() => {
            
        });
    },
	findSelectedItem() {
		let res = {};
		this.fieldsArr.some((item) => {
			console.log("item.id===============", item.id);
			console.log("this.id===============", this.id);
			console.log("id相等===============", item.id == this.id);
			if (item.id == this.id) {
				res = item;
				return;
			}
		});
		return res;
	},
    // 收藏栏位
    operateCollection() {
        console.log('coilingId==', this.$store.state.coilingId);
        console.log('id==', this.id);
        let currentField = this.fieldsArr.find((item) => item.id === this.id)
        console.log('currentField===', currentField)
        if (!currentField) {
            currentField = this.$store.state.fieldsJSON[0]
        }
        console.log('state.Field===', this.$store.state.fieldsJSON)
        if (!this.isCollection) {
            addStar({
                    coilingId: this.$store.state.coilingId,
                    area: this.$route.query.region,
                    type: this.$route.query.type,
                    source: this.$route.query.questionSource,
                    year: this.$route.query.year,
                    collectionType: "test_single",
                    content: JSON.stringify(currentField),
                    pid: 0
                })
                .then((res) => {
                    console.log(res);
                    if (res["code"] == 0) {
                        this.collectionContentSingleId = res["data"];
                        console.log('id===', this.collectionId);
                        this.$message.success("收藏成功！");
                    } else {
                        this.$message.error("收藏失败！");
                        return;
                    }
                })
                .catch((err) => {
                    console.log("addStar err", err);
                });
        } else {
            deleteStar(this.collectionContentSingleId).then((res) => {
                if (res["code"] == 0) {
                    this.$message({
                        message: "取消收藏成功",
                        type: "success",
                    });
                    this.collectionId = 0
                } else {
                    this.$message.error("取消收藏失败");
                    return;
                }
            });
        }
        this.isCollection = !this.isCollection;
    },
    createPaper(){
        console.log("createPaper start..........")
        this.$emit("addSpecialCoilingHandle")
    }
    // 收藏栏位
    /* operateCollection() {
		console.log("filedArr==", this.fieldsArr);
		console.log("id===============", this.id);
		let item = this.findSelectedItem();
		console.log('itemJSON====', JSON.stringify(item));
		this.$emit("collectionAdd", JSON.stringify(item));
		
      /* this.$emit("scjShow", {n1:true,n2:false});
      // this.$message({
      //   message: "删除栏位成功！",
      //   type: "success",
      // });
      this.$notify({
        title: "HTML 片段1",
        dangerouslyUseHTMLString: true,
        message:
          "<strong icon='el-icon-loading'>这是 <i>HTML</i> 片段</strong>",
      }); */
    //}, */
  },
  mounted() {
      console.log("testLevel=====", this.testLevel)
      console.log("optTestLevel====", this.optTestLevel)
  },
};
</script>

<style lang="scss" scoped>
.operateOne {
  width: 100%;
  // background: #fff;
  box-shadow: 0 0 6rem rgba(0, 0, 0, 0.1);
  padding: 10rem 0;
}

.operateList {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14rem;
  color: #666;
  height: 28rem;
  line-height: 28rem;
  cursor: pointer;
  img {
    width: 16rem;
    height: 16rem;
    margin: 0 5rem -2rem 11rem;
  }
  i {
    width: 10rem;
    height: 14rem;
    font-size: 14rem;
    margin: 2rem 10rem 0 2rem;
  }
  .imgOn {
    display: none;
  }
}

.operateList:hover {
  color: #0bae6a;
  background: #d5fae0;
  .img {
    display: none;
  }
  .imgOn {
    display: block;
  }
}

.operateList:hover .operateTwo {
  display: block;
}

.operateTwo {
  position: absolute;
  right: -103rem;
  top: -10rem;
  background: #fff;
  width: 100rem;
  box-shadow: 0 0 6rem rgba(0, 0, 0, 0.1);
  display: none;
  border: 1rem solid rgba(0, 0, 0, 0.15);
  padding: 10rem 0;

  .operateList {
    color: #666;
    height: 28rem;
    line-height: 28rem;
    text-align: center;
    // width: 100%;
    display: block;
  }
  .operateList:hover {
    color: #0bae6a;
    background: #d5fae0;
  }
}


</style>
<style lang="scss">
 .customClass_s {
  //  width: 439rem !important;
  //  height: 190rem !important;
  //  padding: 10rem 20rem 0rem 0rem;
 
   .el-message-box__header .el-message-box__title span {
     margin-left: 20rem;
     font-size: 26rem;
     font-weight: bold;
 
     &::before {
       content: url("../../assets/images/warning.png");
       position: relative;
       top: 5rem;
       left: -10rem;
     }
   }
 
   .el-message-box__container .el-message-box__message p {
     margin-left: 47rem;
   }
 
   .el-message-box__btns {}
 }
.btnCancel_s {
 width: 76rem;
 height: 32rem;
 background: #fff !important;
 color: #0bae6a !important;
 border: 1rem solid #0bae6a !important;
 border-radius: 6rem;
 margin-left: 10rem; // 取消和确认调换位置
 font-size: 14rem;
 line-height: 32rem;
 padding: 0;
}

.btnConfirm_s {
 width: 76rem;
 height: 32rem;
 background: #0bae6a !important;
 color: #fff !important;
 border: 1rem solid #0bae6a !important;
 border-radius: 6rem;
 font-size: 14rem;
 line-height: 32rem;
 padding: 0;
}
// 取消和确认调换位置
.el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
}
</style>

